<div class="tvd-box">
    <div>
        <div class="dollar-value">
            + ${{totalOpportunityTVD.toString() | abbreviateNumber}}
        </div>
        <div class="heading-group">
            <span class="title">
                Total Value Delivered Opportunity
            </span>
            <span class="percent">
                <img src="assets/upArrow.svg" alt="up arrow">{{tvdDeltaPercent}} %
            </span>
        </div>

        <div class="bottom-section">
            <div class="text-group">
                <div class="spacer"></div>
                <div class="subtext current">Current</div>
                <div class="subtext">Opportunities</div>
            </div>

            <!-- Carousel Section -->
            <div class="metrics-carousel">
                <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                    <div class="carousel-group slide" ngxSlickItem *ngFor="let item of carouselItems">
                        <div class="icon">
                            <img src="{{item.imgUrl}}" alt="metrics-icon" />
                            <div class="metric-name">{{item.metricName}}</div>
                        </div>
                        <div class="current-value">${{item.currentTVDValue | abbreviateNumber}}</div>
                        <div class="opportunity-value">${{item.opportunityTVDValue | abbreviateNumber}}</div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</div>